import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiArrowLeft } from 'react-icons/fi';

export default function CookiesPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goBack = () => {
    window.history.back();
  };

  return (
    <div className="min-h-screen bg-brand-black text-white/80 font-inter pt-32 pb-20 px-6">
      <div className="max-w-4xl mx-auto">
        <button onClick={goBack} className="flex items-center gap-2 text-brand-gold hover:text-brand-orange transition-colors mb-8 text-sm uppercase tracking-widest font-cinzel">
          <FiArrowLeft /> Back
        </button>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <h1 className="text-3xl md:text-5xl font-cinzel text-brand-gold mb-8">Cookies Policy</h1>
          <div className="space-y-6 text-sm md:text-base leading-relaxed text-white/60">
            <p><strong>Effective Date:</strong> {new Date().toLocaleDateString()}</p>
            <h2 className="text-xl text-white mt-8 mb-4">1. What Are Cookies</h2>
            <p>As is common practice with almost all professional websites, this site uses cookies, which are tiny files that are downloaded to your computer, to improve your experience. This page describes what information they gather, how we use it, and why we sometimes need to store these cookies.</p>
            
            <h2 className="text-xl text-white mt-8 mb-4">2. How We Use Cookies</h2>
            <p>We use cookies for a variety of reasons detailed below. Unfortunately, in most cases, there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not, in case they are used to provide a service that you use.</p>
            
            <h2 className="text-xl text-white mt-8 mb-4">3. Disabling Cookies</h2>
            <p>You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling cookies will usually result in also disabling certain functionality and features of this site.</p>

            <h2 className="text-xl text-white mt-8 mb-4">4. The Cookies We Set</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Site preferences cookies:</strong> In order to provide you with a great experience on this site, we provide the functionality to set your preferences for how this site runs when you use it.</li>
              <li><strong>Third Party Cookies:</strong> In some special cases, we also use cookies provided by trusted third parties, such as Google Analytics, to help us to understand how you use the site and ways that we can improve your experience.</li>
            </ul>

            <h2 className="text-xl text-white mt-8 mb-4">5. More Information</h2>
            <p>If you are still looking for more information, you can contact us through our preferred contact methods on the website.</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
